/**
 * Landing Page Component
 * Main landing page with hero, features, and sections
 */

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/sections/HeroSection';
import FeaturesSection from '../components/sections/FeaturesSection';
import WorkflowSection from '../components/sections/WorkflowSection';
import AcademicModuleSection from '../components/sections/AcademicModuleSection';
import AuthModal from '../components/auth/AuthModal';

const LandingPage = () => {
  const navigate = useNavigate();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState('signup');
  // Présélection de rôle transmise au formulaire d'inscription
  const [initialRole, setInitialRole] = useState('parent');

  const openSignup = (role = 'parent') => {
    setInitialRole(role);
    setAuthMode('signup');
    setShowAuthModal(true);
  };

  const openLogin = () => {
    setAuthMode('login');
    setShowAuthModal(true);
  };

  const handleAuthSuccess = () => {
    setShowAuthModal(false);
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen font-sans text-sky bg-primary-950 selection:bg-success selection:text-primary">
      {showAuthModal && (
        <AuthModal
          mode={authMode}
          initialRole={initialRole}
          onClose={() => setShowAuthModal(false)}
          switchMode={(mode) => setAuthMode(mode)}
          onSuccess={handleAuthSuccess}
        />
      )}

      <HeroSection openSignup={openSignup} openLogin={openLogin} />
      <FeaturesSection />
      <WorkflowSection />
      <AcademicModuleSection />
      <Footer />
    </div>
  );
};

export default LandingPage;
